import dayjs from "dayjs";
import React from "react";

dayjs.locale("es");

const getRamalTitle = (branch_id, branches) => {
  if (!branch_id) return " de todos los ramales ";

  const branch = branches.find((item) => item.id == branch_id);
  if (!branch) return "";

  return ` de ${branch.name} `;
};

const getDateTitle = (init_date, end_date) => {
  const format = "YYYY-MM-DD HH:mm";
  const esFormat = "DD MMMM YYYY";

  const initDate = dayjs(init_date, format).format(esFormat);
  const endDate = dayjs(end_date, format).format(esFormat);

  return ` del periodo ${initDate} al ${endDate} `;
};

const GraphTitle = ({ title, branches, validation }) => {
  const { init_date, end_date, branch_id, report_type } = validation.values;

  const ramalTitle = getRamalTitle(branch_id, branches);
  const dateTitle = getDateTitle(init_date, end_date);

  const fullTitle = `${title} ${report_type}${ramalTitle}${dateTitle}`;

  return (
    <div>
      <p className="text-center fw-bold mt-5">{fullTitle}</p>
    </div>
  );
};

export default GraphTitle;
